var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppartmentBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m204.431.019h-116.275v70.904l116.275-19.379z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m460.412 481.981v-335.687h-189.412v335.687h-30v-365.687-40.43l-189.412 31.568v374.549h-51.588v30h512v-30zm-74.07-292.55h31.865v30h-31.865zm0 73.138h31.865v30h-31.865zm0 73.137h31.865v30h-31.865zm0 73.138h31.865v30h-31.865zm-73.137-219.413h31.865v30h-31.865zm0 73.138h31.865v30h-31.865zm0 73.137h31.865v30h-31.865zm0 73.138h31.865v30h-31.865zm-146.275-292.55h31.865v30h-31.865zm0 73.137h31.865v30h-31.865zm0 73.138h31.865v30h-31.865zm0 73.137h31.865v30h-31.865zm-73.137-146.275h31.865v30h-31.865zm0 73.138h31.865v30h-31.865zm0 73.137h31.865v30h-31.865zm.932 73.138h103.138v73.137h-30v-43.137h-43.138v43.137h-30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppartmentBold);
export default __webpack_public_path__ + "static/media/appartment_bold.a7b84e35.svg";
export { ForwardRef as ReactComponent };